import {
	SET_EXTERNALHOME_SELECTED_CONTRACT,
	SET_EXTERNALHOME_FIRE_GET_DATA,
	SET_EXTERNALHOME_CONTRACTS,
	SET_EXTERNALHOME_DATASERIES,
	SET_DEFAULT_SELECTED_FILTER_BINDED
} from "./actions/SITE/externalHomeActions";

const initialState = {
	_dataseries: [],
	_selectedContract: null,
	_contratosBase: [],
	_fireLoading: false,
	_defaultSelectedFiltersBinded: true
};

const externalHomeReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_EXTERNALHOME_SELECTED_CONTRACT:
			return {
				...state,
				_selectedContract: action.payload,
			};

		case SET_EXTERNALHOME_FIRE_GET_DATA:
			return {
				...state,
				_fireLoading: action.payload,
			};
			
		case SET_EXTERNALHOME_CONTRACTS:
			return {
				...state,
				_contratosBase: action.payload,
			};	

		case SET_EXTERNALHOME_DATASERIES:
			return {
				...state,
				_dataseries: action.payload,
			};
		case SET_DEFAULT_SELECTED_FILTER_BINDED:
			return {
				...state,
				_defaultSelectedFiltersBinded: action.payload,
			};
		default:
			return state;
	}
};

export default externalHomeReducer;